/** Read-only listings for the Assets home. */

export interface SpecSummary {
  name: string;
  type: string;
  title: string;
  scenes: number;
}
export interface RenderFile {
  file: string;
  url: string;
  sizeMb: number;
  mtime: number;
}

export async function listSpecs(): Promise<SpecSummary[]> {
  const r = await fetch('/api/video/specs', { credentials: 'include' });
  const d = (await r.json().catch(() => ({ specs: [] }))) as { specs?: SpecSummary[] };
  return d.specs ?? [];
}

export async function listRenders(): Promise<RenderFile[]> {
  const r = await fetch('/api/video/renders', { credentials: 'include' });
  const d = (await r.json().catch(() => ({ renders: [] }))) as { renders?: RenderFile[] };
  return d.renders ?? [];
}

/** Turn a render filename into a readable label. */
export function renderLabel(file: string): string {
  return file
    .replace(/\.mp4$/, '')
    .replace(/-\d{6,}$/, '') // drop trailing render stamps
    .replace(/[-_]/g, ' ')
    .replace(/\bprev\b/i, 'preview')
    .trim();
}
